import React, { useMemo } from 'react';

function UserInfoField({
  label,
  fieldName,
  value,
  onChange,
  onBlur,
  required,
  type = 'text',
  error,
  touched,
}) {
  const inputId = useMemo(() => label.toLowerCase().replace(/\s+/g, '-'), [label]);

  const showError = touched && error;

  return (
    <div className="mb-6 w-full">
      <label className="form-label mb-2 flex items-center gap-1" htmlFor={inputId}>
        {label}
        {required && <span className="text-red-400 text-sm">*</span>}
      </label>
      <input
        id={inputId}
        name={fieldName || inputId}
        className={`form-input mt-2 transition-colors duration-200 ${
          showError ? 'border-red-400 focus:border-red-500 focus:ring-red-200' : ''
        }`}
        type={type}
        placeholder={`Enter your ${label.toLowerCase()}...`}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        aria-invalid={showError ? 'true' : 'false'}
        aria-describedby={showError ? `${inputId}-error` : undefined}
      />
      {showError && (
        <p
          id={`${inputId}-error`}
          className="text-red-500 text-sm mt-1.5 flex items-center gap-1"
          role="alert"
        >
          <svg className="w-4 h-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
              clipRule="evenodd"
            />
          </svg>
          {error}
        </p>
      )}
    </div>
  );
}

export default UserInfoField;
